import Hero from "../components/Hero";
import Highlights from "../components/Highlights";
import Services from "../components/Services";
import PriceList from "../components/PriceList";
import Reviews from "../components/Reviews";
import FeaturedCars from "../components/FeaturedCars";
import Locations from "../components/Locations";
import ContactForm from "../components/ContactForm";

export default function Home() {
  return (
    <main>
      <Hero />
      <Highlights />
      <Services />
      <PriceList />
      <Reviews />
      <FeaturedCars />
      <Locations />
      <ContactForm />
    </main>
  );
}
